
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drafts/[pageNumber]",
      function () {
        return require("private-next-pages/drafts/[pageNumber]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drafts/[pageNumber]"])
      });
    }
  